// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import QuotePaymentPlanCreationComponent from '../../components/quotes/quote-payment-plan-creation/quote-payment-plan-creation';

// Primereact imports
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Steps } from 'primereact/steps';
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Redux
import { connect } from 'react-redux';
import { getQuoteList, getQuoteDebitDirectConfiguration, getQuoteSettingList, updateQuoteOperationData, updateGeneratedPaymentRef } from '../../redux/actions/quote';
import FinancialService from '../../redux/services/finance';
import QuoteService from '../../redux/services/quote';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './quotes.scss';

// Utils
import { COMPANY_DATA, PAYMENT_CHANNEL_BANK_TRANSFER, PAYMENT_CHANNEL_CREDIT_CARD, PAYMENT_CHANNEL_DIRECT_DEBIT, PAYMENT_CHANNEL_MB, PAYMENT_CHANNEL_MBWAY, PAYMENT_METHOD_CC, PAYMENT_METHOD_DEBIT_DIRECT, PAYMENT_METHOD_MB, PAYMENT_METHOD_MBWAY, PERSONAL_COMPANY_DATA, PERSONAL_DATA, QUOTE_ALL_YEARS, QUOTE_CURRENT_CONFIG_YEAR, QUOTE_PLAN_ANNUAL, QUOTE_PLAN_MONTHLY, QUOTE_PLAN_SEMESTRAL, QUOTE_START_YEAR, QUOTE_STATE_FINANCE_PROCESS, QUOTE_STATE_FREE, QUOTE_STATE_PAYED, QUOTE_STATE_WAITING_PAYMENT } from '../../common/constants';
import PaymentService from '../../redux/services/payment';
import { getAssociateData } from '../../redux/actions/profile';
import { getPrettyDate, monthDiff } from '../../common/utils/date-utils';
import { SEPA_COUNTRY_LIST, WORLD_LIST } from '../../common/lists/countries';
import { validateNIF } from '../../common/utils/validation-utils';
import { isMobileOnly } from 'react-device-detect';
import { getCreditCardFormConfig } from '../../common/utils/credit-card-utils';
import _, { groupBy } from 'lodash';
import { QUOTE_PAYMENT_PLAN_ACTIVE, QUOTE_PAYMENT_PLAN_PART_PAYED } from '../../common/lists/quote';

class QuotesPage extends Component {

    constructor(props) {
      super(props);
      this._toast = React.createRef();
      this.state = {
          showGenerateQuotesDialog: false,
          dialogSteps: [
              { label: this.props.t("quotes.dialog.tabs.quote-plan"), command: null },
              { label: this.props.t("quotes.dialog.tabs.payment-method"), command: null },
              { label: this.props.t("quotes.dialog.tabs.confirmation"), command: null}
          ],
          selectedYear: null,
          confirmQuotes: [],
          dialogActiveIndex: 0,
          selectedQuotePlan: null,
          selectedPaymentMethod: null,
          mobilePhoneNumberPrefix: "351",
          mobilePhoneNumber: null,
          nib: "PT50",
          nibCountry: { code: "PT50", name: "Portugal" },
          directDebitAcceptance: false,
          mbEntity: "",
          mbReference: "",
          mbValue: "",
          mbDueDate: "",
          quotesGenerated: false,
          selectedMonthToPay: null,
          availableMonths: [],
          semestralSelectedMonthToPay: null,
          semestralAvailableMonths: [],
          validNib: true,
          validDirectDebitAcceptance: true,
          emptyNib: false,
          validMobilePhoneNumberPrefix: true,
          validMobilePhoneNumber: true,
          validMobilePhoneNumberFormat: true,
          showCardForm: false,
          serverLoading: false,
          // Invoice data management
          validCompanyEntity: true,
          validCompanyNipc: true,
          // Quote payment plan management
          paymentPlanEligible: false,
          showQuotePaymentPlanDialog: false,
          availablePaymentPlanParts: []
      };
      this.accept = {};
    }

    componentDidMount() {
        // Check if the page was called from SIBS
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let formIdParam = params.get('id');

        if(formIdParam === null) {
            this.props.getAssociateData(this.props.registrationRef);
            this.props.getQuoteDebitDirectConfiguration(this.props.associate.associateId);
            this.props.getQuoteList(this.props.associate.associateId);
            this.props.getQuoteSettingList();

            let selectedMonthToPay = {};
            let dtNow = new Date();
            let monthlyAvailableMonths = this.getQuotesMonthList(dtNow.getMonth());

            switch(dtNow.getMonth()) {
                case 0: selectedMonthToPay = { name: this.props.t("general.months.jan") + " " + dtNow.getFullYear(), code: "1-" + dtNow.getFullYear() }; break;
                case 1: selectedMonthToPay = { name: this.props.t("general.months.fev") + " " + dtNow.getFullYear(), code: "2-" + dtNow.getFullYear() }; break;
                case 2: selectedMonthToPay = { name: this.props.t("general.months.mar") + " " + dtNow.getFullYear(), code: "3-" + dtNow.getFullYear() }; break;
                case 3: selectedMonthToPay = { name: this.props.t("general.months.abr") + " " + dtNow.getFullYear(), code: "4-" + dtNow.getFullYear() }; break;
                case 4: selectedMonthToPay = { name: this.props.t("general.months.mai") + " " + dtNow.getFullYear(), code: "5-" + dtNow.getFullYear() }; break;
                case 5: selectedMonthToPay = { name: this.props.t("general.months.jun") + " " + dtNow.getFullYear(), code: "6-" + dtNow.getFullYear() }; break;
                case 6: selectedMonthToPay = { name: this.props.t("general.months.jul") + " " + dtNow.getFullYear(), code: "7-" + dtNow.getFullYear() }; break;
                case 7: selectedMonthToPay = { name: this.props.t("general.months.ago") + " " + dtNow.getFullYear(), code: "8-" + dtNow.getFullYear() }; break;
                case 8: selectedMonthToPay = { name: this.props.t("general.months.set") + " " + dtNow.getFullYear(), code: "9-" + dtNow.getFullYear() }; break;
                case 9: selectedMonthToPay = { name: this.props.t("general.months.out") + " " + dtNow.getFullYear(), code: "10-" + dtNow.getFullYear() }; break;
                case 10: selectedMonthToPay = { name: this.props.t("general.months.nov") + " " + dtNow.getFullYear(), code: "11-" + dtNow.getFullYear() }; break;
                case 11: selectedMonthToPay = { name: this.props.t("general.months.dez") + " " + dtNow.getFullYear(), code: "12-" + dtNow.getFullYear() }; break;
            }

            QuoteService.getQuoteList(this.props.associate.associateId)
            .then((response) => {
                for (let i = 0; i < response.quotes.length; i++) {
                    if(response.quotes[i].year === dtNow.getFullYear() && response.quotes[i].month === dtNow.getMonth() + 1) {
                        if(response.quotes[i].state === 'Pago') {
                            monthlyAvailableMonths = this.getQuotesMonthList(dtNow.getMonth() + 1);    
                            
                            switch(dtNow.getMonth() + 1) {
                                case 0: selectedMonthToPay = { name: this.props.t("general.months.jan") + " " + dtNow.getFullYear(), code: "1-" + dtNow.getFullYear() }; break;
                                case 1: selectedMonthToPay = { name: this.props.t("general.months.fev") + " " + dtNow.getFullYear(), code: "2-" + dtNow.getFullYear() }; break;
                                case 2: selectedMonthToPay = { name: this.props.t("general.months.mar") + " " + dtNow.getFullYear(), code: "3-" + dtNow.getFullYear() }; break;
                                case 3: selectedMonthToPay = { name: this.props.t("general.months.abr") + " " + dtNow.getFullYear(), code: "4-" + dtNow.getFullYear() }; break;
                                case 4: selectedMonthToPay = { name: this.props.t("general.months.mai") + " " + dtNow.getFullYear(), code: "5-" + dtNow.getFullYear() }; break;
                                case 5: selectedMonthToPay = { name: this.props.t("general.months.jun") + " " + dtNow.getFullYear(), code: "6-" + dtNow.getFullYear() }; break;
                                case 6: selectedMonthToPay = { name: this.props.t("general.months.jul") + " " + dtNow.getFullYear(), code: "7-" + dtNow.getFullYear() }; break;
                                case 7: selectedMonthToPay = { name: this.props.t("general.months.ago") + " " + dtNow.getFullYear(), code: "8-" + dtNow.getFullYear() }; break;
                                case 8: selectedMonthToPay = { name: this.props.t("general.months.set") + " " + dtNow.getFullYear(), code: "9-" + dtNow.getFullYear() }; break;
                                case 9: selectedMonthToPay = { name: this.props.t("general.months.out") + " " + dtNow.getFullYear(), code: "10-" + dtNow.getFullYear() }; break;
                                case 10: selectedMonthToPay = { name: this.props.t("general.months.nov") + " " + dtNow.getFullYear(), code: "11-" + dtNow.getFullYear() }; break;
                                case 11: selectedMonthToPay = { name: this.props.t("general.months.dez") + " " + dtNow.getFullYear(), code: "12-" + dtNow.getFullYear() }; break;
                            }
                        }
                    }          
                }
    
                this.setState({
                    selectedMonthToPay: selectedMonthToPay,
                    availableMonths: monthlyAvailableMonths,
                    semestralSelectedMonthToPay: dtNow.getMonth() < 6 ? 
                                                        { name: this.props.t("general.months.jun") + " " + dtNow.getFullYear(), code: "6-" + dtNow.getFullYear() }
                                                        :
                                                        { name: this.props.t("general.months.dez") + " " + dtNow.getFullYear(), code: "12-" + dtNow.getFullYear() },
                    semestralAvailableMonths: this.getSemestralQuotesMonthList()
                });
    
                this.props.updateQuoteOperationData({
                    showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
                    confirmQuotes: this.props.operation.confirmQuotes, 
                    fee: this.props.operation.fee,
                    dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                    selectedQuotePlan: this.props.operation.selectedQuotePlan,
                    beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
                    endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
                    selectedPaymentMethod: null,
                    nIPC: null,
                    nIPCCountry: { code: "Portugal", name: "Portugal" },
                    entity: null,
                    selectedInvoiceData: PERSONAL_DATA,
                    quotePaymentPlan: this.props.operation.quotePaymentPlan,
                    selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
                });
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
            });

            this.checkAssociateEligibityForQuotePaymentPlan();
        }
        else {
            FinancialService.getCreditCardCheckoutStatus(formIdParam)
            .then((response) => {
                let successCodesRegex = new RegExp('^(000\.000\.|000\.100\.1|000\.[36])');

                // Confirm if payment was successful
                if(successCodesRegex.test(response.checkout.result.code)) {
                    this.generateQuotes();
                }
                else {
                    this.updateDialogActiveIndex(1);
                    this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.credit-card-error"), life: 5000 });
                }

                window.history.pushState("", "", '/area-membros/quotes');
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
            });

            this.setState({
                showCardForm: false
            });
        }
    }

    checkAssociateEligibityForQuotePaymentPlan() {
         QuoteService.checkAssociateEligibityForQuotePaymentPlan(this.props.associate.associateId)
        .then((response) => {
            this.setState({
                paymentPlanEligible: response.eligible
            });          

            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
                confirmQuotes: this.props.operation.confirmQuotes, 
                fee: this.props.operation.fee,
                dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                selectedQuotePlan: this.props.operation.selectedQuotePlan,
                beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
                endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                entity: this.props.operation.entity,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: response.paymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });

            if(response.paymentPlan !== null) {
                var availablePaymentPlanParts = [];
                var firstParcelToPay = -1;

                for (let i = 0; i < response.paymentPlan.paymentParts.length; i++) {
                    if(response.paymentPlan.paymentParts[i].paymentStateId !== QUOTE_PAYMENT_PLAN_PART_PAYED) {
                        if(firstParcelToPay === -1) {
                            firstParcelToPay = i;
                        }

                        availablePaymentPlanParts.push({
                            code: i, 
                            name: "Prestação " + (i+1) + " - " + response.paymentPlan.paymentParts[i].numMonths + " meses - " + this.formatFeeValue(response.paymentPlan.paymentParts[i].amount),
                            disabled: firstParcelToPay !== 0
                        })
                    }
                }

                this.props.updateQuoteOperationData({
                    showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
                    confirmQuotes: this.props.operation.confirmQuotes, 
                    fee: this.props.operation.fee,
                    dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                    selectedQuotePlan: this.props.operation.selectedQuotePlan,
                    beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
                    endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
                    selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                    nIPC: this.props.operation.nIPC,
                    nIPCCountry: this.props.operation.nIPCCountry,
                    entity: this.props.operation.entity,
                    selectedInvoiceData: this.props.operation.selectedInvoiceData,
                    quotePaymentPlan: response.paymentPlan,
                    selectedPaymentPlanPart: availablePaymentPlanParts.length > 0 ? availablePaymentPlanParts[0] : null
                });

                this.setState({
                    availablePaymentPlanParts: availablePaymentPlanParts,
                });
            }
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }

    getYearsList() {
        let yearsList = [
            { name: this.props.t("quotes.form.all"), code: QUOTE_ALL_YEARS }
        ];

        let cursorYear = QUOTE_START_YEAR;

        while (cursorYear <= QUOTE_CURRENT_CONFIG_YEAR) {
            yearsList.push({ name: cursorYear.toString(), code: cursorYear.toString() });
            cursorYear++;
        }

        return yearsList;
    }
    
    downloadInvoice(invoiceRef) {
      FinancialService.generateInvoicePdf(invoiceRef)
        .then((response) => {
            window.open(response.output.pdfUrl, '_blank');
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }

    amountBodyTemplate(rowData) {
        if(rowData.amount === null) {
            return "";
        }
        else {
            if(rowData.amount.toString().includes(".")) {
                let amountParts = rowData.amount.toString().split(".");

                if(amountParts[1].length === 1) {
                    return rowData.amount + "0 €";
                }
                else {
                    return rowData.amount + " €";
                }     
            }
            else {
                return rowData.amount + ".00 €";
            }
        }
    }

    priceBodyTemplate(rowData) {
        if(rowData.price === null) {
            return "";
        }
        else {
            if(rowData.price.toString().includes(".")) {
                let priceParts = rowData.price.toString().split(".");

                if(priceParts[1].length === 1) {
                    return rowData.price + "0 €";
                }
                else {
                    return rowData.price + " €";
                }     
            }
            else {
                return rowData.price + ".00 €";
            }
        }
    }

    monthBodyTemplate(rowData) {
        switch(rowData.month) {
          case 1: return this.props.t("general.months.jan"); break;
          case 2: return this.props.t("general.months.fev"); break;
          case 3: return this.props.t("general.months.mar"); break;
          case 4: return this.props.t("general.months.abr"); break;
          case 5: return this.props.t("general.months.mai"); break;
          case 6: return this.props.t("general.months.jun"); break;
          case 7: return this.props.t("general.months.jul"); break;
          case 8: return this.props.t("general.months.ago"); break;
          case 9: return this.props.t("general.months.set"); break;
          case 10: return this.props.t("general.months.out"); break;
          case 11: return this.props.t("general.months.nov"); break;
          case 12: return this.props.t("general.months.dez"); break;
        }
    }

    dateBodyTemplate(rowData, column) {
      if(rowData[column] !== null) {
        return rowData[column] !== undefined ? rowData[column].replace('T',' ') : "";
      }
      else {
        return "";
      }
    }

    stateBodyTemplate(rowData) {
        if(rowData.state === QUOTE_STATE_PAYED) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("quotes.form.payed")}</span>;
        }
        else if(rowData.state === QUOTE_STATE_WAITING_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("quotes.form.waiting-payment")}</span>;
        }
        else if(rowData.state === QUOTE_STATE_FREE) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#000000'}}>{this.props.t("quotes.form.free")}</span>;
        }
        else if(rowData.state === QUOTE_STATE_FINANCE_PROCESS) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("quotes.form.finance-process")}</span>;
        }
        else {
          return <span className={'state-badge'} style={{background: '#b80406', color: '#FFFFFF'}}>{this.props.t("quotes.form.missing")}</span>;
       }
    }

    paymentChannelBodyTemplate(rowData) {
        if(rowData.paymentChannel === PAYMENT_CHANNEL_MB) {
            return this.props.t("quotes.form.payment-channel-mb");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_MBWAY) {
            return this.props.t("quotes.form.payment-channel-mbway");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_CREDIT_CARD) {
            return this.props.t("quotes.form.payment-channel-credit-card");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_BANK_TRANSFER) {
            return this.props.t("quotes.form.payment-channel-bank-transfer");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_DIRECT_DEBIT) {
            return this.props.t("quotes.form.payment-channel-direct-debit");
        }
        else {
            return null;
        }
    }

    invoiceDownloadBodyTemplate(rowData) {
        return rowData.state === QUOTE_STATE_PAYED ? <Button icon="pi pi-download" onClick={() => this.downloadInvoice(rowData.invoiceRef)} /> : null;
    }

    showGenerateQuotesDialog() {
        if(this.props.operation.quotePaymentPlan !== undefined && this.props.operation.quotePaymentPlan !== null && this.props.operation.quotePaymentPlan.paymentPlanStateId === QUOTE_PAYMENT_PLAN_ACTIVE) {
            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: true,
                confirmQuotes: this.props.operation.confirmQuotes,
                fee: null,
                dialogActiveIndex: 1, 
                selectedQuotePlan: QUOTE_PLAN_MONTHLY,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                entity: this.props.operation.entity,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: this.props.operation.quotePaymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });
        }
        else {
            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: true,
                confirmQuotes: this.props.operation.confirmQuotes,
                fee: null,
                dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                selectedQuotePlan: this.props.operation.selectedQuotePlan,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                entity: this.props.operation.entity,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: this.props.operation.quotePaymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });
        }
    }

    hideGenerateQuotesDialog() {
        this.setState({
          mobilePhoneNumber: null, 
          nib: null,
          mbEntity: "",
          mbReference: "",
          mbValue: "",
          mbDueDate: "",
          quotesGenerated: false,
          emptyNib: false,
          validNib: true,
          validDirectDebitAcceptance: true,
          validMobilePhoneNumber: true,
          validMobilePhoneNumberFormat: true,
          validMobilePhoneNumberPrefix: true,
          validCompanyEntity: true,
          validCompanyNipc: true
        });

        this.props.updateQuoteOperationData({
            showGenerateQuotesDialog: false,
            confirmQuotes: [],
            fee: null,
            dialogActiveIndex: 0, 
            selectedQuotePlan: null,
            selectedPaymentMethod: null,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            entity: this.props.operation.entity,
            selectedInvoiceData: this.props.operation.selectedInvoiceData,
            quotePaymentPlan: this.props.operation.quotePaymentPlan,
            selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
        });
    }

    acceptRemoveDebitDirect() {
      QuoteService.cancelQuoteDebitDirect(this.props.associate.associateId)
        .then((response) => {
            this.props.getQuoteDebitDirectConfiguration(this.props.associate.associateId);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }
    
    confirmRemoval(evt) {
        if(!this.isCurrentDateOutsideDebitDirectPeriod()) {
            confirmPopup({
                target: evt.currentTarget, // document.getElementById('data-quote-container'),
                message: this.props.t("quotes.cancel-debit-direct"),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.props.t("general.yes"),
                rejectLabel: this.props.t("general.no"),
                accept: () => this.acceptRemoveDebitDirect()
            });
        }
        else {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.dialog.direct-debit-disabled").replace("{0}", this.props.beginSubscriptionPeriodDay).replace("{1}", this.props.endSubscriptionPeriodDay), life: 3000 });
        }
    }

    chooseQuotePlan(quotePlanId) {
        this.props.updateQuoteOperationData({
            showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog,
            confirmQuotes: this.props.operation.confirmQuotes,
            fee: null,
            dialogActiveIndex: 1, 
            selectedQuotePlan: quotePlanId,
            selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            entity: this.props.operation.entity,
            selectedInvoiceData: this.props.operation.selectedInvoiceData,
            quotePaymentPlan: this.props.operation.quotePaymentPlan,
            selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
        });
    }

    checkAllQuotesArePayed() {
        if(this.props.directDebit !== null) return true; 
        
        for (let i = 0; i < this.props.quotes.length; i++) {
            if(this.props.quotes[i].state !== QUOTE_STATE_PAYED && this.props.quotes[i].state !== QUOTE_STATE_FREE && this.props.quotes[i].state !== QUOTE_STATE_FINANCE_PROCESS) return false; 
        }

        return true;
    }

    checkQuotesInPayment() {
        if(this.props.directDebit !== null) return true; 
        
        for (let i = 0; i < this.props.quotes.length; i++) {
            if(this.props.quotes[i].state === QUOTE_STATE_WAITING_PAYMENT) return true; 
        }

        return false;
    }

    checkPendingDirectDebitPayments() {
        for (let i = 0; i < this.props.quotes.length; i++) {
            if(this.props.quotes[i].state === QUOTE_STATE_WAITING_PAYMENT &&
               this.props.quotes[i].paymentChannel === PAYMENT_CHANNEL_DIRECT_DEBIT) return true; 
        }

        return false;
    }

    confirmDebitDirect() {
        let validEntity = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);
        let validNipc = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);

        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
            validEntity = (this.props.operation.entity !== null && this.props.operation.entity !== "");
            validNipc = (this.props.operation.nIPC !== null && this.props.operation.nIPC !== "") && validateNIF(this.props.operation.nIPC);

            this.setState({
                validCompanyEntity: validEntity,
                validCompanyNipc: validNipc
            });
        }

        if(this.state.directDebitAcceptance === false || validEntity === false || validNipc === false) {
            this.setState({
                validDirectDebitAcceptance: false
            });
        }
        else {        
            if(this.state.nib === null) {
                this.setState({
                    emptyNib: true,
                    validDirectDebitAcceptance: true
                });
            }
            else {
                PaymentService.validateIBAN(this.state.nib.replace(' ','')).then((response) => { 
                    this.setState({
                        validNib: response
                    });

                    if(response === true) {
                        this.setState({
                            emptyNib: false,
                            validDirectDebitAcceptance: true
                        });

                        let company = null;
                        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
                            company = {
                                entity: this.props.operation.entity,
                                nIPC: this.props.operation.nIPC,
                                nIPCCountry: this.props.operation.nIPCCountry.code
                            }
                        }
        
                        this.setState({
                            serverLoading: true
                        });

                        QuoteService.activateQuoteDebitDirect(this.props.associate.associateId, 
                                                                this.state.nib.replace(' ',''), 
                                                                this.props.operation.selectedQuotePlan,
                                                                this.getDirectDebitAuthorization(),
                                                                company)
                            .then((response) => {
                                this.props.getQuoteDebitDirectConfiguration(this.props.associate.associateId);
                                this.updateDialogActiveIndex(2);
                            
                                this.setState({
                                    serverLoading: false,
                                    quotesGenerated: true,
                                    validDirectDebitAcceptance: true
                                });
                            })
                            .catch(error => {
                                this.setState({
                                    serverLoading: false
                                });

                                this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
                            });
                    }

                }).catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
                });
                }
        }
    }

    getDirectDebitAuthorization() {
        return this.props.t("quotes.dialog.direct-debit-acceptance-part-1") + 
               " " + this.props.associate.personalData.name + 
               this.props.t("quotes.dialog.direct-debit-acceptance-part-2") + 
               this.props.ballot.ballotRef + 
               this.props.t("quotes.dialog.direct-debit-acceptance-part-3") + " " + 
               this.props.t("quotes.dialog.direct-debit-acceptance-part-4") + " " +
               this.getQuotePlanDescription(this.props.operation.selectedQuotePlan) + ". " + 
               this.props.t("quotes.dialog.direct-debit-acceptance-part-5") + 
               " - " + this.props.t("quotes.dialog.direct-debit-acceptance-part-6") + 
               " - " + this.props.t("quotes.dialog.direct-debit-acceptance-part-7");
    }

    confirmPaymentMethod() {
        let validEntity = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);
        let validNipc = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);

        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
            validEntity = (this.props.operation.entity !== null && this.props.operation.entity !== "");
            validNipc = (this.props.operation.nIPC !== null && this.props.operation.nIPC !== "") && validateNIF(this.props.operation.nIPC);

            this.setState({
                validCompanyEntity: validEntity,
                validCompanyNipc: validNipc
            });
        }

        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {

            let validMobilePhoneNumber = (this.state.mobilePhoneNumberPrefix !== null && this.state.mobilePhoneNumberPrefix !== "" && this.state.mobilePhoneNumber !== null && this.state.mobilePhoneNumber !== "");
            let validMobilePhoneNumberFormat = true;

            if(validMobilePhoneNumber) {
                if(this.state.mobilePhoneNumberPrefix === "351") {
                    validMobilePhoneNumberFormat = (this.state.mobilePhoneNumber.length === 9);
                }
            }

            this.setState({
                validMobilePhoneNumber: validMobilePhoneNumber,
                validMobilePhoneNumberFormat: validMobilePhoneNumberFormat,
                validMobilePhoneNumberPrefix: this.state.mobilePhoneNumberPrefix !== ""
            });

            if(validMobilePhoneNumber && validMobilePhoneNumberFormat && validEntity && validNipc) {
                this.updateDialogActiveIndex(2);
                this.getQuotesToBePayed();
            }
        }
        else {
            if(validEntity && validNipc) {
                this.updateDialogActiveIndex(2);
                this.getQuotesToBePayed();
            }
        }
    }

    getQuotesToBePayed() {
        if(this.props.operation.selectedPaymentPlanPart !== undefined && this.props.operation.selectedPaymentPlanPart !== null) {
            return this.getPaymentPlanPartQuotesToBePayed();
        }

        let nextQuoteToBePayed = this.getOldestQuoteToPay();

        let payUntilDate = (this.props.operation.selectedQuotePlan === QUOTE_PLAN_MONTHLY) ? this.state.selectedMonthToPay.code.split("-") : this.state.semestralSelectedMonthToPay.code.split("-");

        if(nextQuoteToBePayed !== null) {
            QuoteService.getQuotesToBePayed({
                associateId: this.props.associate.associateId,
                quotePlan: this.props.operation.selectedQuotePlan,
                year: nextQuoteToBePayed.year, 
                month: nextQuoteToBePayed.month,
                customMaxYear: Number(payUntilDate[1]),
                customMaxMonth: Number(payUntilDate[0])
              })
              .then((response) => {
                  let quotes = [];
      
                  for (let i = 0; i < response.quotes.length; i++) {
                      quotes.push({
                          year: response.quotes[i].year,
                          month: response.quotes[i].month,
                          discount: response.quotes[i].discount,
                          invoiceItem: response.quotes[i].invoiceItem,
                          price: response.quotes[i].price
                      });              
                  }

                  this.props.updateQuoteOperationData({
                        showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog,
                        confirmQuotes: quotes,
                        fee: response.fee,
                        dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                        selectedQuotePlan: this.props.operation.selectedQuotePlan,
                        selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                        nIPC: this.props.operation.nIPC,
                        nIPCCountry: this.props.operation.nIPCCountry,
                        entity: this.props.operation.entity,
                        selectedInvoiceData: this.props.operation.selectedInvoiceData,
                        quotePaymentPlan: this.props.operation.quotePaymentPlan,
                        selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
                    });
              })
              .catch(error => {
                  this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
              });
        }
    }

    getOldestQuoteToPay() {
        for (let i = 0; i < this.props.quotes.length; i++) {
            if(this.props.quotes[i].state === QUOTE_STATE_PAYED || this.props.quotes[i].state === QUOTE_STATE_FREE || this.props.quotes[i].state === QUOTE_STATE_FINANCE_PROCESS) {
                if(this.props.quotes[i].month === 12) {
                    return { year: this.props.quotes[i].year + 1, month: 1 };
                }
                else {
                    return { year: this.props.quotes[i].year, month: this.props.quotes[i].month + 1 };
                }
            }
        }

        return { year: this.props.quotes[this.props.quotes.length -1].year, month: this.props.quotes[this.props.quotes.length -1].month };
    }

    getPaymentPlanPartQuotesToBePayed() {
        var selectedPaymentPlanPart = this.props.operation.quotePaymentPlan.paymentParts[this.props.operation.selectedPaymentPlanPart.code];       

        QuoteService.getQuotesToBePayed({
            associateId: this.props.associate.associateId,
            quotePlan: this.props.operation.selectedQuotePlan,
            year: selectedPaymentPlanPart.quoteStartYear, 
            month: selectedPaymentPlanPart.quoteStartMonth,
            customMaxYear: selectedPaymentPlanPart.quoteEndYear,
            customMaxMonth: selectedPaymentPlanPart.quoteEndMonth,
            quotePaymentPlanPartId: selectedPaymentPlanPart.quotePaymentPlanPartId
        })
        .then((response) => {
            let quotes = [];

            for (let i = 0; i < response.quotes.length; i++) {
                quotes.push({
                    year: response.quotes[i].year,
                    month: response.quotes[i].month,
                    discount: response.quotes[i].discount,
                    invoiceItem: response.quotes[i].invoiceItem,
                    price: response.quotes[i].price
                });              
            }

            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog,
                confirmQuotes: quotes,
                fee: response.fee,
                dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                selectedQuotePlan: this.props.operation.selectedQuotePlan,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                entity: this.props.operation.entity,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: this.props.operation.quotePaymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }

    getQuotesMonthList(startMonth) {
        let monthList = [];
        let dtNow = new Date();

        let cursorMonth = 0;

        while (cursorMonth <= 12) {
            if(startMonth <= cursorMonth) {

                switch(cursorMonth) {
                    case 0: monthList.push({ name: this.props.t("general.months.jan") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 1: monthList.push({ name: this.props.t("general.months.fev") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 2: monthList.push({ name: this.props.t("general.months.mar") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 3: monthList.push({ name: this.props.t("general.months.abr") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 4: monthList.push({ name: this.props.t("general.months.mai") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 5: monthList.push({ name: this.props.t("general.months.jun") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 6: monthList.push({ name: this.props.t("general.months.jul") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 7: monthList.push({ name: this.props.t("general.months.ago") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 8: monthList.push({ name: this.props.t("general.months.set") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 9: monthList.push({ name: this.props.t("general.months.out") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 10: monthList.push({ name: this.props.t("general.months.nov") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                    case 11: monthList.push({ name: this.props.t("general.months.dez") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); break;
                }
            }
            
            cursorMonth++;
        }

        // Show next year on the last month of the current year
        /*if(dtNow.getMonth() === 11) {
            monthList.push({ name: this.props.t("general.months.jan") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.fev") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() });
            monthList.push({ name: this.props.t("general.months.mar") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.abr") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() });
            monthList.push({ name: this.props.t("general.months.mai") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() });
            monthList.push({ name: this.props.t("general.months.jun") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.jul") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.ago") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.set") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.out") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.nov") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
            monthList.push({ name: this.props.t("general.months.dez") + " " + dtNow.getFullYear(), code: (cursorMonth+1) + "-" + dtNow.getFullYear() }); 
        }*/

        return monthList;
    }

    getSemestralQuotesMonthList() {
        let monthList = [];
        let dtNow = new Date();

        if(dtNow.getMonth() < 6) {
            monthList.push({ name: this.props.t("general.months.jun") + " " + dtNow.getFullYear(), code: "6-" + dtNow.getFullYear() });
        }

        monthList.push({ name: this.props.t("general.months.dez") + " " + dtNow.getFullYear(), code: "12-" + dtNow.getFullYear() });

        return monthList;
    }

    processQuotePayment() {
        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC) {
            this.generateCreditCardCheckout();
        }
        else {
            if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY &&
               (this.state.mobilePhoneNumber === null || this.state.mobilePhoneNumber === "")) {
                this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.no-mobile-phone"), life: 5000 });
            }
            else {
                this.generateQuotes();
            }
        }
    }

    generateCreditCardCheckout() {
        QuoteService.generateCreditCardCheckout({
            associateId: this.props.associate.associateId,
            quotes: this.props.operation.confirmQuotes,
            email: this.props.associate.personalData.email
        })
        .then((response) => {
            const script1 = document.createElement("script");
            script1.innerHTML = getCreditCardFormConfig(this.props.associate.personalData.city,
                this.props.associate.personalData.cP4,
                this.props.associate.personalData.cP3,
                this.props.associate.personalData.addressLine1,
                this.props.associate.personalData.addressLine2,
                this.props.t("quotes.messages.invalid-holder"));
            script1.async = true;
            
            const script2 = document.createElement("script");
            script2.src = process.env.REACT_APP_SIBS_WIDGET_URL + response.checkout.id;
            script2.async = true;

            document.body.appendChild(script1);
            document.body.appendChild(script2);

            this.setState({
                showCardForm: true
            });

            this.props.updateGeneratedPaymentRef(response.paymentRef);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }

    generateQuotes() {
        var quotePaymentPlanPartId = null;

        if(this.props.operation.quotePaymentPlan !== undefined && this.props.operation.quotePaymentPlan !== null && this.props.operation.selectedPaymentPlanPart !== undefined && this.props.operation.selectedPaymentPlanPart !== null) {
            var selectedPaymentPlanPart = this.props.operation.quotePaymentPlan.paymentParts[this.props.operation.selectedPaymentPlanPart.code];     
            quotePaymentPlanPartId = selectedPaymentPlanPart.quotePaymentPlanPartId;  
        }

        let quotesToGenerate = [];
      
        for (let i = 0; i < this.props.operation.confirmQuotes.length; i++) {
            quotesToGenerate.push({
                year: this.props.operation.confirmQuotes[i].year,
                month: this.props.operation.confirmQuotes[i].month,
                discount: this.props.operation.confirmQuotes[i].discount,
                price: this.props.operation.confirmQuotes[i].price,
                invoiceItem: this.props.operation.confirmQuotes[i].invoiceItem
            });              
        }

        let quoteRequest = { 
            paymentChannel: this.props.operation.selectedPaymentMethod,
            mobilePhoneNumber: this.state.mobilePhoneNumberPrefix + "#" + this.state.mobilePhoneNumber,
            quotes: quotesToGenerate,
            company: null,
            quotePaymentPlanPartId: quotePaymentPlanPartId
        };

        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC)
        {
            quoteRequest.paymentRef = this.props.generatedPaymentRef;
        }

        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
            quoteRequest.company = {
                entity: this.props.operation.entity,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry.code
            }
        }

        this.setState({
            serverLoading: true
        });

        QuoteService.generateQuotes(this.props.associate.associateId, quoteRequest)
          .then((response) => {
                this.setState({
                    serverLoading: false,
                    quotesGenerated: true,
                    mbEntity: response.mbEntity,
                    mbReference: response.mbReference,
                    mbValue: this.amountBodyTemplate(response),
                    mbDueDate: getPrettyDate(response.dueDate)
                });

                // reload associate quotes
                this.props.getQuoteList(this.props.associate.associateId);
          })
          .catch(error => {
                this.setState({
                    serverLoading: false
                });

                if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.mbway-error"), life: 5000 });
                }
                else {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
                }
          });
    }

    getQuotePlanPrice(quotePlan) {
        for (let i = 0; i < this.props.settings.length; i++) {
            if(this.props.settings[i].quotePlanId === quotePlan) return Number(this.props.settings[i].price).toFixed(2);
        }

        return null;
    }

    getQuotePlanInvoiceItem(quotePlan) {
        for (let i = 0; i < this.props.settings.length; i++) {
            if(this.props.settings[i].quotePlanId === quotePlan) return this.props.settings[i].invoiceItem;
        }

        return null;
    }

    getQuotePriceTotal(quotes) {

        let basePrice = 0;

        for (let i = 0; i < quotes.length; i++) {
            basePrice += Number(quotes[i].price);
        }

        let total = Number(basePrice.toFixed(2));

        if(this.props.operation.fee !== null) {
            total +=  Number(this.props.operation.fee);
        }

        total = total.toFixed(2);

        if(total.includes(".")) {
            let amountParts = total.split(".");
            if(amountParts[1].length === 1) {
                return total + "0 €";
            }
            else {
                return total + " €";
            }     
        }
        else {
            return total + ".00 €";
        }
    }

    formatFeeValue(fee) {
        if(fee !== null) {
            fee = fee.toFixed(2);

            if(fee.includes(".")) {
                let amountParts = fee.split(".");
                if(amountParts[1].length === 1) {
                    return fee + "0 €";
                }
                else {
                    return fee + " €";
                }     
            }
            else {
                return fee + ".00 €";
            }
        }
    }

    onChangeNIBCountry(nibCountry) {
        this.setState({
            nibCountry: nibCountry,
            nib: (nibCountry.code.length > 50) ? nibCountry.code.slice(50) : nibCountry.code
        });
    }

    onChangeNIB(nib) {
        this.setState({
            nib: (nib.length > 50) ? nib.slice(50) : nib
        });
    }

    updatePaymentMethod(paymentMethod) {
        this.props.updateQuoteOperationData({
            showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog,
            confirmQuotes: this.props.operation.confirmQuotes,
            fee: null,
            dialogActiveIndex: this.props.operation.dialogActiveIndex, 
            selectedQuotePlan: this.props.operation.selectedQuotePlan,
            selectedPaymentMethod: paymentMethod,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            entity: this.props.operation.entity,
            selectedInvoiceData: this.props.operation.selectedInvoiceData,
            quotePaymentPlan: this.props.operation.quotePaymentPlan,
            selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
        });
    }

    updateInvoiceData(invoiceData) {
        this.props.updateQuoteOperationData({
            showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
            confirmQuotes: this.props.operation.confirmQuotes, 
            fee: this.props.operation.fee,
            dialogActiveIndex: this.props.operation.dialogActiveIndex, 
            selectedQuotePlan: this.props.operation.selectedQuotePlan,
            beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
            endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
            selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
            entity: this.props.operation.entity,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            selectedInvoiceData: invoiceData,
            quotePaymentPlan: this.props.operation.quotePaymentPlan,
            selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
        });
    }

    updateCompanyInvoiceData(column, value) {
        if(column === "companyEntity") {
            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
                confirmQuotes: this.props.operation.confirmQuotes, 
                fee: this.props.operation.fee,
                dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                selectedQuotePlan: this.props.operation.selectedQuotePlan,
                beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
                endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                entity: value,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: this.props.operation.quotePaymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });
        }

        if(column === "companyNipc") {
            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
                confirmQuotes: this.props.operation.confirmQuotes, 
                fee: this.props.operation.fee,
                dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                selectedQuotePlan: this.props.operation.selectedQuotePlan,
                beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
                endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                entity: this.props.operation.entity,
                nIPC: value,
                nIPCCountry: this.props.operation.nIPCCountry,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: this.props.operation.quotePaymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });
        }

        if(column === "companyNipcCountry") {
            this.props.updateQuoteOperationData({
                showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog, 
                confirmQuotes: this.props.operation.confirmQuotes, 
                fee: this.props.operation.fee,
                dialogActiveIndex: this.props.operation.dialogActiveIndex, 
                selectedQuotePlan: this.props.operation.selectedQuotePlan,
                beginSubscriptionPeriodDay: this.props.operation.beginSubscriptionPeriodDay,
                endSubscriptionPeriodDay: this.props.operation.endSubscriptionPeriodDay,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                entity: this.props.operation.entity,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: value,
                selectedInvoiceData: this.props.operation.selectedInvoiceData,
                quotePaymentPlan: this.props.operation.quotePaymentPlan,
                selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
            });
        }
    }

    updateDialogActiveIndex(dialogIndex) {
        this.props.updateQuoteOperationData({
            showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog,
            confirmQuotes: this.props.operation.confirmQuotes,
            fee: null,
            dialogActiveIndex: dialogIndex, 
            selectedQuotePlan: this.props.operation.selectedQuotePlan,
            selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            entity: this.props.operation.entity,
            selectedInvoiceData: this.props.operation.selectedInvoiceData,
            quotePaymentPlan: this.props.operation.quotePaymentPlan,
            selectedPaymentPlanPart: this.props.operation.selectedPaymentPlanPart
        });
    }

    isCurrentDateOutsideDebitDirectPeriod() {
        let currentDay = new Date().getDate();
        return (currentDay > Number(this.props.beginSubscriptionPeriodDay) || currentDay < Number(this.props.endSubscriptionPeriodDay));
    }

    updateSelectedPaymentPlanPart(selectedPaymentPlanPart) {
        this.props.updateQuoteOperationData({
            showGenerateQuotesDialog: this.props.operation.showGenerateQuotesDialog,
            confirmQuotes: this.props.operation.confirmQuotes,
            fee: this.props.operation.fee,
            dialogActiveIndex: this.props.operation.dialogActiveIndex, 
            selectedQuotePlan: this.props.operation.selectedQuotePlan,
            selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            entity: this.props.operation.entity,
            selectedInvoiceData: this.props.operation.selectedInvoiceData,
            quotePaymentPlan: this.props.operation.quotePaymentPlan,
            selectedPaymentPlanPart: selectedPaymentPlanPart
        });
    }

    getQuotePlanDescription(quotePlanId) {
        let quotePlan = "";

        switch (quotePlanId) {
            case QUOTE_PLAN_MONTHLY: 
                quotePlan = this.props.t("quotes.dialog.plans.month.title");
                break;
            case QUOTE_PLAN_SEMESTRAL: 
                quotePlan = this.props.t("quotes.dialog.plans.semestral.title");
                break;
            case QUOTE_PLAN_ANNUAL: 
                quotePlan = this.props.t("quotes.dialog.plans.annual.title");
                break;
            default:
                break;
        }

        return quotePlan;
    }
    
    getDirectDebitSuccessMessage(quotePlanId) {
        let quotePlan = "";

        switch (quotePlanId) {
            case QUOTE_PLAN_MONTHLY: 
                quotePlan = this.props.t("quotes.dialog.success-debit-direct-month");
                break;
            case QUOTE_PLAN_SEMESTRAL: 
                quotePlan = this.props.t("quotes.dialog.success-debit-direct-semestral");
                break;
            case QUOTE_PLAN_ANNUAL: 
                quotePlan = this.props.t("quotes.dialog.success-debit-direct-annual");
                break;
            default:
                break;
        }

        return quotePlan;
    }

    transformQuotesDataSource(serverQuotes) {
        let transformedQuotes = [];
        let filteredQuotes = [];
        let quotesGroupedByInvoice = _(serverQuotes).groupBy(x => x.creationDate).map((value, key) => ({invoiceRef: key, quotes: value})).value();

        if(this.state.selectedYear === null) this.setState( { selectedYear: this.getDefaultQuoteFilter() });

        for (let i = quotesGroupedByInvoice.length - 1; i >= 0; i--) {

            if(quotesGroupedByInvoice[i].invoiceRef !== "null") {
                let month = <div>
                {
                    quotesGroupedByInvoice[i].quotes.map((quote) => { 
                        return <p>{this.monthBodyTemplate(quote)}</p>;
                    })
                }
                </div>

                transformedQuotes.push({
                    year: quotesGroupedByInvoice[i].quotes[0].year,
                    month: month,
                    state: quotesGroupedByInvoice[i].quotes[0].state,
                    paymentDate: quotesGroupedByInvoice[i].quotes[0].paymentDate,
                    paymentChannel: quotesGroupedByInvoice[i].quotes[0].paymentChannel,
                    amount: quotesGroupedByInvoice[i].quotes[0].amount,
                    invoiceRef: quotesGroupedByInvoice[i].quotes[0].invoiceRef
                });
            }
            else {
                let quotesGroupedByYear = _(quotesGroupedByInvoice[i].quotes).groupBy(x => x.year).map((value, key) => ({year: key, quotes: value})).value();

                for (let j = quotesGroupedByYear.length - 1; j >= 0; j--) {
                    let month = <div>
                    {
                        quotesGroupedByYear[j].quotes.map((quote) => { 
                            return <p>{this.monthBodyTemplate(quote)}</p>;
                        })
                    }
                    </div>
    
                    transformedQuotes.push({
                        year: quotesGroupedByYear[j].quotes[0].year,
                        month: month,
                        state: quotesGroupedByYear[j].quotes[0].state,
                        paymentDate: quotesGroupedByYear[j].quotes[0].paymentDate,
                        paymentChannel: quotesGroupedByYear[j].quotes[0].paymentChannel,
                        amount: quotesGroupedByYear[j].quotes[0].amount,
                        invoiceRef: quotesGroupedByYear[j].invoiceRef
                    });
                }
            }

            // Apply filterde); 
            filteredQuotes = [];

            if(this.state.selectedYear === null) {
                if(this.getDefaultQuoteFilter().code === QUOTE_ALL_YEARS) {
                    filteredQuotes = transformedQuotes;
                }
                else {
                    for (let z = 0; z < transformedQuotes.length; z++) {
                        if(transformedQuotes[z].year === Number(this.getDefaultQuoteFilter().code)) {
                            filteredQuotes.push(transformedQuotes[z]);
                        }
                    }
                }
            }
            else if(this.state.selectedYear.code === QUOTE_ALL_YEARS) {
                filteredQuotes = transformedQuotes;
            }
            else {
                for (let z = 0; z < transformedQuotes.length; z++) {
                    if(transformedQuotes[z].year === Number(this.state.selectedYear.code)) {
                        filteredQuotes.push(transformedQuotes[z]);
                    }
                }
            }
        }
        
        return filteredQuotes;
    }

    getDefaultQuoteFilter() {
        let maxYear = 0;

        for (let i = 0; i < this.props.quotes.length; i++) {
            if(this.props.quotes[i].month === 12
                &&  (this.props.quotes[i].state === QUOTE_STATE_PAYED || this.props.quotes[i].state === QUOTE_STATE_FREE || this.props.quotes[i].state === QUOTE_STATE_FINANCE_PROCESS)) {
                    if(maxYear > this.props.quotes[i].year) {
                        maxYear = this.props.quotes[i].year;
                    }
            }
        }

        if(maxYear === 0) {
            return { name: this.props.t("quotes.form.all"), code: QUOTE_ALL_YEARS }; 
        }
        else {
            if(maxYear === QUOTE_CURRENT_CONFIG_YEAR) {
                return { name: (maxYear).toString(), code: (maxYear).toString() }; 
            }
            else {
                return { name: (maxYear + 1).toString(), code: (maxYear + 1).toString() }; 
            }
        }
    }

    hasQuotesWithDiscount(quotes) {
        let quotesWithDiscount = false;

        for (let i = 0; i < quotes.length; i++) {
            if(quotes[i].discount === true) {
                quotesWithDiscount = true;
                break;
            }
        }
        return quotesWithDiscount;
    }

    // Quote plan availability functions

    checkQuotePlanAvailability(quotePlanId) {
        let planSettings = null;

        for (let i = 0; i < this.props.settings.length; i++) {
            if(this.props.settings[i].quotePlanId === quotePlanId) {
                planSettings = this.props.settings[i];
                break;
            }
        }

        if(planSettings !== null) {
            let currentMonth = new Date().getMonth() + 1;

            for (let j = 0; j < planSettings.offPeriods.length; j++) {
                if(currentMonth >= planSettings.offPeriods[j].beginMonth && currentMonth <= planSettings.offPeriods[j].endMonth) {
                    return false;
                }
            }

            return true;
        }

        return false;
    }

    checkMBAvailability() {
        if(this.props.operation.selectedQuotePlan === QUOTE_PLAN_SEMESTRAL || this.props.operation.selectedQuotePlan === QUOTE_PLAN_ANNUAL) return true;

        if(this.state.selectedMonthToPay === null) return false;

        let latestPayedQuote = this.getOldestQuoteToPay();
        let currentMonthToPay = this.state.selectedMonthToPay.code.split("-");
        let monthsToPay = monthDiff(new Date(latestPayedQuote.year, latestPayedQuote.month, 1), new Date(currentMonthToPay[1], currentMonthToPay[0], 1)) + 1;

        return monthsToPay >= this.props.mbMinimumMonths;
    }

    showQuotePaymentPlanDialog() {
        this.setState({
            showQuotePaymentPlanDialog: true
        });
    }

    hideQuotePaymentPlanDialog() {
        this.setState({
            showQuotePaymentPlanDialog: false
        });
    }

    render() {
      return (
        <div>
          <PageTitleComponent title={this.props.t("quotes.title")} />
            { 
                this.props.operation !== undefined && this.props.operation !== null ?
                    <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                        <div className='col-1'></div>
                        <div className="col-10">
                            <div id="data-quote-container" className="card mgt-20">
                            {
                                this.props.payments !== null ? 
                                <div className="grid">
                                    <div className="col-6 t-align-left">
                                        {
                                            this.state.selectedYear !== null ?
                                                this.state.selectedYear.code === QUOTE_ALL_YEARS ? 
                                                    <span style={{fontSize:"16px"}}>{this.props.t("quotes.subtitle-total")}</span>
                                                    :
                                                    <span style={{fontSize:"16px"}}>{this.props.t("quotes.subtitle") + " " + this.state.selectedYear.name}</span>
                                                :
                                                null
                                        }
                                    </div>
                                    <div className='col-6 t-align-right'>
                                        <label className='mgr-10' htmlFor="quote-year">{this.props.t("quotes.form.year-header")}:</label>
                                        <Dropdown value={this.state.selectedYear} id="quote-year" options={this.getYearsList()} optionLabel="name" onChange={(evt) => this.setState({ selectedYear: evt.value })}></Dropdown>
                                    </div>
                                    {
                                        this.props.directDebit !== null ?
                                        <div className="col-12 t-align-left">
                                            <span>{this.props.t("quotes.debit-direct")} <a className='c-pointer' onClick={(evt) => this.confirmRemoval(evt)}>{this.props.t("general.click-here")}</a>.</span>
                                        </div>
                                        : null
                                    }
                                    <div className="col-12">
                                        <DataTable value={this.transformQuotesDataSource(this.props.quotes)} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("quotes.messages.no-quotes")}>
                                            <Column field="year" header={this.props.t("quotes.form.year-header")} style={{ minWidth: '50px' }}  />
                                            <Column field="month" header={this.props.t("quotes.form.month-header")}   />
                                            <Column field="state" header={this.props.t("quotes.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '10rem' }}  />
                                            <Column field="paymentDate" header={this.props.t("quotes.form.payment-date-header")} body={(data) => this.dateBodyTemplate(data, 'paymentDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="amount" header={this.props.t("quotes.form.amount-header")} body={(data) => this.amountBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                            <Column field="paymentChannel" header={this.props.t("quotes.form.channel-header")} body={(data) => this.paymentChannelBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                            <Column field="invoiceRef" header={this.props.t("quotes.form.invoice-header")} body={(data) => this.invoiceDownloadBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                        </DataTable>
                                    </div>
                                    {
                                        this.state.paymentPlanEligible ? 
                                            <div className="col-6 t-align-left">
                                                <Button label={this.props.t("quotes.form.create-payment-plan")} onClick={() => this.showQuotePaymentPlanDialog()} />
                                            </div>      
                                            : null
                                    }
                                    {
                                        !this.checkAllQuotesArePayed() && !this.checkQuotesInPayment() ?
                                            <div className={this.state.paymentPlanEligible ? "col-6 t-align-right" : "col-12 t-align-right"}>
                                                <Button label={this.props.t("quotes.form.pay-quotes")} onClick={() => this.showGenerateQuotesDialog()} /> 
                                            </div>      
                                            : null
                                    }          
                                    {
                                        this.checkPendingDirectDebitPayments() ?
                                        <div className="col-12 t-align-left">
                                            <b style={{fontSize:"14px"}}><span>{this.props.t("quotes.open-direct-debit-payment")}</span></b>
                                        </div>
                                        : null
                                    }            
                                </div>
                                : null
                            }
                            </div>
                        </div>
                        <div className='col-1'></div>
                    </div>
                    : null
            }
            <Toast position='bottom-left' ref={this._toast} />
            <ConfirmPopup />
            { 
                this.props.operation !== undefined && this.props.operation !== null ?
                    <Dialog visible={this.props.operation.showGenerateQuotesDialog} style={{ width: '850px' }} header={this.props.t("quotes.dialog.title")} modal onHide={() => this.hideGenerateQuotesDialog() }>
                        {
                            this.state.serverLoading ? 
                                <div className='container'>
                                    <div className="col-12 t-align-center">
                                        <i className="mgt-100 mgb-100 pi pi-spin pi-spinner" style={{ fontSize: '4rem', color: '#0073aa' }}></i>
                                    </div>
                                </div>
                                :
                                <div>
                                    <Steps model={this.state.dialogSteps} activeIndex={this.props.operation.dialogActiveIndex} readOnly={true} />
                                    {
                                        this.props.operation.dialogActiveIndex === 0 ?
                                            <div className="grid">
                                                <div className="col-12 lg:col-4">
                                                    <div className="p-3 h-full">
                                                        <div className="shadow-2 p-3 h-full flex flex-column surface-card" style={{ borderRadius: '6px' }}>
                                                            <div className="text-900 font-medium text-xl mb-2">{this.props.t("quotes.dialog.plans.month.title")}</div>
                                                            <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
                                                            <div className="flex align-items-center">
                                                            <span className="font-bold text-2xl text-900">{this.getQuotePlanPrice(QUOTE_PLAN_MONTHLY)} €</span>
                                                                <span className="ml-2 font-medium text-600">{this.props.t("quotes.dialog.plans.month.subtitle")}</span>
                                                            </div>
                                                            <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
                                                            <ul className="list-none p-0 m-0 flex-grow-1">
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span>{this.props.t("quotes.dialog.plans.month.line-1")}</span>
                                                                </li>
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span>{this.props.t("quotes.dialog.plans.month.line-2")}</span>
                                                                </li>
                                                            </ul>
                                                            <hr className="mb-3 mx-0 border-top-1 border-none surface-border mt-auto" />
                                                            <Button label={this.props.t("general.choose")} className="p-3 w-full mt-auto" onClick={() => this.chooseQuotePlan(QUOTE_PLAN_MONTHLY)}></Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 lg:col-4">
                                                    <div className="p-3 h-full">
                                                        <div className="shadow-2 p-3 h-full flex flex-column surface-card" style={{ borderRadius: '6px' }}>
                                                            <div className="text-900 font-medium text-xl mb-2">{this.props.t("quotes.dialog.plans.semestral.title")}</div>
                                                            <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
                                                            <div className="flex align-items-center">
                                                                <span className="font-bold text-2xl text-900">{this.getQuotePlanPrice(QUOTE_PLAN_SEMESTRAL)} €</span>
                                                                <span className="ml-2 font-medium text-600">{this.props.t("quotes.dialog.plans.semestral.subtitle")}</span>
                                                            </div>
                                                            <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
                                                            <ul className="list-none p-0 m-0 flex-grow-1">
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span>{this.props.t("quotes.dialog.plans.semestral.line-1")}</span>
                                                                </li>
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span>{this.props.t("quotes.dialog.plans.semestral.line-2")}</span>
                                                                </li>
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span><b>{this.props.t("quotes.dialog.plans.semestral.line-3")}</b></span>
                                                                </li>
                                                            </ul>
                                                            <hr className="mb-3 mx-0 border-top-1 border-none surface-border" />
                                                            <Button label={this.props.t("general.choose")} className="p-3 w-full" onClick={() => this.chooseQuotePlan(QUOTE_PLAN_SEMESTRAL)} disabled={!this.checkQuotePlanAvailability(QUOTE_PLAN_SEMESTRAL)}></Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 lg:col-4">
                                                    <div className="p-3 h-full">
                                                        <div className="shadow-2 p-3 flex flex-column surface-card" style={{ borderRadius: '6px' }}>
                                                            <div className="text-900 font-medium text-xl mb-2">{this.props.t("quotes.dialog.plans.annual.title")}</div>
                                                            <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
                                                            <div className="flex align-items-center">
                                                            <span className="font-bold text-2xl text-900">{this.getQuotePlanPrice(QUOTE_PLAN_ANNUAL)} €</span>
                                                                <span className="ml-2 font-medium text-600">{this.props.t("quotes.dialog.plans.annual.subtitle")}</span>
                                                            </div>
                                                            <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
                                                            <ul className="list-none p-0 m-0 flex-grow-1">
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span>{this.props.t("quotes.dialog.plans.annual.line-1")}</span>
                                                                </li>
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span>{this.props.t("quotes.dialog.plans.annual.line-2")}</span>
                                                                </li>           
                                                                <li className="flex align-items-center mb-3">
                                                                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                                                    <span><b>{this.props.t("quotes.dialog.plans.annual.line-3")}</b></span>
                                                                </li>        
                                                            </ul>
                                                            <hr className="mb-3 mx-0 border-top-1 border-none surface-border" />
                                                            <Button label={this.props.t("general.choose")} className="p-3 w-full" onClick={() => this.chooseQuotePlan(QUOTE_PLAN_ANNUAL)} disabled={!this.checkQuotePlanAvailability(QUOTE_PLAN_ANNUAL)}></Button>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    {
                                        this.props.operation.dialogActiveIndex === 1 ?
                                        <div className='grid'>
                                            {
                                                this.props.operation.selectedQuotePlan === QUOTE_PLAN_MONTHLY && this.props.operation.quotePaymentPlan !== null && this.props.operation.quotePaymentPlan.paymentPlanStateId === QUOTE_PAYMENT_PLAN_ACTIVE ?
                                                    <>      
                                                        <div className='col-12 mgt-20'>
                                                            <label className='mgr-10' htmlFor="month-pay"><b>{this.props.t("quotes.form.payment-plan-active")}</b></label>
                                                        </div>
                                                        <div className='col-12'>
                                                            <label className='mgr-10' htmlFor="month-pay"><b>{this.props.t("quotes.form.payment-plan-part-to-pay")}</b></label>
                                                            <Dropdown value={this.props.operation.selectedPaymentPlanPart} id="month-pay" options={this.state.availablePaymentPlanParts} optionLabel="name" onChange={(evt) => this.updateSelectedPaymentPlanPart(evt.value)}></Dropdown>
                                                        </div>
                                                    </>
                                                    : null
                                            }
                                            {
                                                this.props.operation.selectedQuotePlan === QUOTE_PLAN_MONTHLY && (this.props.operation.quotePaymentPlan === null || (this.props.operation.quotePaymentPlan !== null && this.props.operation.quotePaymentPlan.paymentPlanStateId !== QUOTE_PAYMENT_PLAN_ACTIVE)) ?
                                                    <div className='col-12 mgt-20'>
                                                        <label className='mgr-10' htmlFor="month-pay">{this.props.t("quotes.form.month-to-pay")}:</label>
                                                        <Dropdown disabled={new Date().getMonth() === 11} value={this.state.selectedMonthToPay} id="month-pay" options={this.state.availableMonths} optionLabel="name" onChange={(evt) => this.setState({ selectedMonthToPay: evt.value })}></Dropdown>
                                                    </div>
                                                    : null
                                            }
                                            {
                                                this.props.operation.selectedQuotePlan === QUOTE_PLAN_SEMESTRAL ?
                                                    <div className='col-12 mgt-20'>
                                                        <label className='mgr-10' htmlFor="month-pay">{this.props.t("quotes.form.month-to-pay")}:</label>
                                                        <Dropdown disabled={new Date().getMonth() === 11} value={this.state.semestralSelectedMonthToPay} id="month-pay" options={this.state.semestralAvailableMonths} optionLabel="name" onChange={(evt) => this.setState({ semestralSelectedMonthToPay: evt.value })}></Dropdown>
                                                    </div>
                                                    : null
                                            }
                                            <div className='col-3'>
                                                <div className='mgt-50'>
                                                    {
                                                        this.props.operation.quotePaymentPlan !== null || this.checkMBAvailability() ?
                                                            <div className="field-radiobutton">
                                                                <RadioButton inputId="ref-mb" name="payment-method" value={PAYMENT_METHOD_MB} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MB)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB} />
                                                                <label htmlFor="ref-mb">{this.props.t("quotes.dialog.payment-methods.mb")}</label>
                                                            </div>
                                                            : null
                                                    }
                                                    {
                                                        this.props.operation.quotePaymentPlan !== null || (this.props.operation.selectedQuotePlan === QUOTE_PLAN_MONTHLY && this.checkMBAvailability()) ?
                                                            <div className="field-radiobutton">
                                                                <RadioButton inputId="cc" name="payment-method" value={PAYMENT_METHOD_CC} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_CC)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC} />
                                                                <label htmlFor="cc">{this.props.t("quotes.dialog.payment-methods.cc")}</label>
                                                            </div>
                                                            : null
                                                    }
                                                    {
                                                        this.props.operation.selectedQuotePlan === QUOTE_PLAN_SEMESTRAL || this.props.operation.selectedQuotePlan === QUOTE_PLAN_ANNUAL ?
                                                            <div className="field-radiobutton">
                                                                <RadioButton inputId="cc" name="payment-method" value={PAYMENT_METHOD_CC} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_CC)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC} />
                                                                <label htmlFor="cc">{this.props.t("quotes.dialog.payment-methods.cc")}</label>
                                                            </div>
                                                            : null
                                                    }
                                                    <div className="field-radiobutton">
                                                        <RadioButton inputId="mb-way" name="payment-method" value={PAYMENT_METHOD_MBWAY} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MBWAY)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY} />
                                                        <label htmlFor="mb-way">{this.props.t("quotes.dialog.payment-methods.mbway")}</label>
                                                    </div>
                                                    { // this.props.operation.selectedQuotePlan === QUOTE_PLAN_MONTHLY && 
                                                        (this.props.operation.quotePaymentPlan === null || (this.props.operation.quotePaymentPlan !== null && this.props.operation.quotePaymentPlan.paymentPlanStateId !== QUOTE_PAYMENT_PLAN_ACTIVE)) ?
                                                            <div className="field-radiobutton">
                                                                <RadioButton inputId="dd" name="payment-method" value={PAYMENT_METHOD_DEBIT_DIRECT} disabled={this.isCurrentDateOutsideDebitDirectPeriod()} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_DEBIT_DIRECT)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_DEBIT_DIRECT} />
                                                                <label htmlFor="dd">{this.props.t("quotes.dialog.payment-methods.debit-direct")}</label>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-9 t-align-left mgt-20'>
                                            {
                                                this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                                    <div className='grid'>
                                                        <div className='col-12 t-align-left mgt-10'>
                                                            <p>{this.props.t("quotes.dialog.mbway")}</p>
                                                        </div> 
                                                        <div className='col-4 t-align-left mgt-10'>
                                                            <label className='mgr-10' htmlFor="mobile-number-prefix">{this.props.t("quotes.dialog.mobile-number-prefix")}</label>
                                                            <InputText autocomplete="off" value={this.state.mobilePhoneNumberPrefix} className={!this.state.validMobilePhoneNumberPrefix ? "p-invalid" : null} id="mobile-number-prefix" type="number" style={{width:"80px"}} onChange={(evt) => this.setState({mobilePhoneNumberPrefix: evt.target.value})} />
                                                            { this.state.validMobilePhoneNumberPrefix ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                        </div> 
                                                        <div className='col-8 t-align-left mgt-10'>
                                                            <label className='mgr-10' htmlFor="mobile-number">{this.props.t("quotes.dialog.mobile-number")}</label>
                                                            <InputText autocomplete="off" value={this.state.mobilePhoneNumber} className={!this.state.validMobilePhoneNumber ? "p-invalid" : null} id="mobile-number" type="number" onChange={(evt) => this.setState({mobilePhoneNumber: evt.target.value})} />
                                                            { this.state.validMobilePhoneNumber ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                            { this.state.validMobilePhoneNumberFormat ? null : <p><small className="p-error">{this.props.t("general.wrong-phone-format")}</small></p>  }
                                                        </div> 
                                                    </div>
                                                    : this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_DEBIT_DIRECT ?
                                                    <div className='col-12 t-align-left mgt-10'>
                                                        <p>{this.props.t("quotes.dialog.nib")}</p>
                                                        <div className='grid'>
                                                            <div className='col-3 t-align-left'>
                                                                <Dropdown id="sepaCountry" value={this.state.nibCountry} options={SEPA_COUNTRY_LIST} optionLabel="name" onChange={(evt) => this.onChangeNIBCountry(evt.value)}></Dropdown>
                                                            </div>
                                                            <div className='col-9 t-align-left'>
                                                                <InputText value={this.state.nib} className={!this.state.validNib ? "p-invalid" : null} id="nib" type="text" style={{width:'300px'}} onChange={(evt) => this.onChangeNIB(evt.target.value)} />
                                                                { !this.state.emptyNib ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                { this.state.validNib ? null : <p><small className="p-error">{this.props.t("quotes.dialog.invalid-nib")}</small></p>  }
                                                            </div>
                                                        </div>
                                                        <div className="mgt-10" style={{textAlign:"justify"}}>
                                                            <Checkbox inputId="checkDirectDebit" binary className="mr-2" onChange={e => this.setState({directDebitAcceptance: e.checked })} checked={this.state.directDebitAcceptance} />
                                                            <label htmlFor="checkDirectDebit">{this.props.t("quotes.dialog.direct-debit-acceptance-part-1")} <b>{this.props.associate.personalData.name}</b>{this.props.t("quotes.dialog.direct-debit-acceptance-part-2")} <b>{this.props.ballot.ballotRef}</b>{this.props.t("quotes.dialog.direct-debit-acceptance-part-3")}</label>
                                                            <p style={{marginTop: "10px"}}>{this.props.t("quotes.dialog.direct-debit-acceptance-part-4")} <b>({this.getQuotePlanDescription(this.props.operation.selectedQuotePlan)})</b>.</p>
                                                            <p>{this.props.t("quotes.dialog.direct-debit-acceptance-part-5")}</p>
                                                            <li>{this.props.t("quotes.dialog.direct-debit-acceptance-part-6")}</li>
                                                            <li>{this.props.t("quotes.dialog.direct-debit-acceptance-part-7")}</li>
                                                        </div>
                                                        { this.state.validDirectDebitAcceptance ? null : <p className='mgt-10'><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                    </div>
                                                    : <div className='col-12 t-align-left mgt-10'></div>
                                            }
                                            <div className='grid'>
                                                <div className='col-12 t-align-left mgt-10'>
                                                    <b>{this.props.t("quotes.dialog.invoice-data")}</b>
                                                    <div className="field-radiobutton mgt-10">
                                                        <RadioButton inputId="personal-data" name="invoice-data" value={PERSONAL_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_DATA)} checked={this.props.operation.selectedInvoiceData === PERSONAL_DATA} />
                                                        <label htmlFor="personal-data">{this.props.t("quotes.dialog.my-invoice-data")}<b>{this.props.t("quotes.dialog.name-nif").replace("{0}", this.props.associate.personalData.name).replace("{1}", this.props.associate.personalData.nif)}</b></label>
                                                    </div>
                                                    <div className="field-radiobutton">
                                                        <RadioButton inputId="company-data" name="invoice-data" value={PERSONAL_COMPANY_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_COMPANY_DATA)} checked={this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA} />
                                                        <label htmlFor="company-data">{this.props.t("quotes.dialog.personal-company-invoice-data")}</label>
                                                    </div>
                                                    <div className="field-radiobutton">
                                                        <RadioButton inputId="company-data" name="invoice-data" value={COMPANY_DATA} onChange={(e) => this.updateInvoiceData(COMPANY_DATA)} checked={this.props.operation.selectedInvoiceData === COMPANY_DATA} />
                                                        <label htmlFor="company-data">{this.props.t("quotes.dialog.other-company-invoice-data")}</label>
                                                    </div>
                                                </div> 
                                                {
                                                    this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA ?
                                                        <>
                                                            <div className='col-12 t-align-left'>
                                                                <label className='mgr-10' htmlFor="company-entity">{this.props.t("quotes.dialog.company-entity")}</label>
                                                                <InputText value={this.props.operation.entity} className={!this.state.validCompanyEntity ? "p-invalid" : null} id="company-entity" style={{width: "350px", marginLeft:"20px"}} type="text" onChange={(evt) => this.updateCompanyInvoiceData("companyEntity", evt.target.value)} />
                                                                { this.state.validCompanyEntity ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                            </div>
                                                            <div className='col-6 t-align-left mgt-10'> 
                                                                <label className='mgr-10' htmlFor="company-nipc">{this.props.t("quotes.dialog.company-nipc")}</label>
                                                                <InputText value={this.props.operation.nIPC} className={!this.state.validCompanyNipc ? "p-invalid" : null} id="company-nipc" type="text" style={{width:"100px"}} onChange={(evt) => this.updateCompanyInvoiceData("companyNipc", evt.target.value)} />
                                                                { this.state.validCompanyNipc ? null : <p><small className="p-error">{this.props.t("quotes.messages.invalid-nif")}</small></p>  }
                                                            </div> 
                                                            <div className='col-6 t-align-left mgt-10'>
                                                                <label className='mgr-10' htmlFor="nipc-country">{this.props.t("quotes.dialog.company-nipc-country")}</label>
                                                                <Dropdown id="nipc-country" style={{width:"150px"}} value={this.props.operation.nIPCCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateCompanyInvoiceData("companyNipcCountry", evt.value)}></Dropdown>
                                                            </div>
                                                        </>
                                                        : null
                                                } 
                                            </div>
                                            </div>
                                            {
                                                this.props.operation.dialogActiveIndex === 1 && this.props.operation.selectedQuotePlan === QUOTE_PLAN_MONTHLY ?
                                                    <div className='col-12 t-align-left mgt-10'>
                                                        <p><b>{this.props.t("general.note")}</b>: {this.props.t("quotes.dialog.mb-enabled").replace("{0}", this.props.mbMinimumMonths)}</p> 
                                                    </div>
                                                    : null
                                            }
                                            {
                                                this.isCurrentDateOutsideDebitDirectPeriod() ?
                                                    <div className='col-12 t-align-left mgt-10'>
                                                        <p><b>{this.props.t("general.note")}</b>: {this.props.t("quotes.dialog.direct-debit-disabled").replace("{0}", this.props.beginSubscriptionPeriodDay).replace("{1}", this.props.endSubscriptionPeriodDay)}</p> 
                                                    </div>
                                                    : null
                                            }
                                            <div className="col-6 t-align-left mgt-10">
                                                <Button className='p-button-danger' label={this.props.t("general.back")} onClick={() => this.updateDialogActiveIndex(0)} />
                                            </div>     
                                            {
                                                this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_DEBIT_DIRECT ?
                                                    <div className="col-6 t-align-right mgt-10">
                                                        <Button className='p-button-success' label={this.props.t("general.confirm")} onClick={() => this.confirmDebitDirect()} />
                                                    </div>  
                                                    : 
                                                    this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB || this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC || this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                                        <div className="col-6 t-align-right mgt-10">
                                                            <Button label={this.props.t("general.next")} onClick={() => this.confirmPaymentMethod()} />
                                                        </div>  
                                                        : null
                                            } 
                                        </div>
                                        : null
                                    }
                                    {
                                        this.props.operation.dialogActiveIndex === 2 && this.props.operation.selectedPaymentMethod !== PAYMENT_METHOD_DEBIT_DIRECT && this.state.quotesGenerated === false ?
                                            <div className='grid mgt-20'>
                                                <div className="col-12">
                                                <p style={{fontSize:'13px'}}>{this.props.t("quotes.dialog.confirm-quotes")}</p>
                                                </div>
                                                <div className="col-12">
                                                <DataTable value={this.props.operation.confirmQuotes} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("quotes.messages.no-quotes")}>
                                                    <Column field="year" header={this.props.t("quotes.form.year-header")} style={{ minWidth: '50px' }}  />
                                                    <Column field="month" header={this.props.t("quotes.form.month-header")} body={(data) => this.monthBodyTemplate(data)} style={{ minWidth: '50px' }}  />
                                                    <Column field="price" header={this.props.t("quotes.form.amount-header")} body={(data) => this.priceBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                                </DataTable>
                                                </div>
                                                {
                                                    this.props.operation.fee !== null ?
                                                        <div className="col-12 t-align-right">
                                                            <p style={{fontSize:'13px', fontWeight:'bold', color:'#bd130c'}}>{this.props.t("quotes.form.fees")} {this.formatFeeValue(this.props.operation.fee)}</p>
                                                        </div>
                                                        : null
                                                }
                                                <div className="col-12 t-align-right">
                                                    <p style={{fontSize:'13px', fontWeight:'bold'}}>{this.props.t("quotes.form.total")} {this.getQuotePriceTotal(this.props.operation.confirmQuotes)}</p>
                                                </div>
                                                {
                                                    this.hasQuotesWithDiscount(this.props.operation.confirmQuotes) ?
                                                        <div className="col-12 t-align-left">
                                                            <p style={{fontSize:'12px', fontWeight:'bold'}}>{this.props.t("quotes.form.discount")}</p>
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                            : null
                                    }
                                    {
                                        this.props.operation.dialogActiveIndex === 2 ?
                                            <div className='grid mgt-30 mgb-30'>
                                                {
                                                    this.state.quotesGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_DEBIT_DIRECT ?
                                                        <div className="col-12 t-align-center mgt-20">
                                                            <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                            <span style={{fontSize:'15px'}}>{this.getDirectDebitSuccessMessage(this.props.operation.selectedQuotePlan)}</span>
                                                        </div>  
                                                        : null
                                                }
                                                {
                                                    this.state.quotesGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB ?
                                                        <>
                                                            <div className="col-12 t-align-center mgt-20">
                                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                                <span style={{fontSize:'15px'}}>{this.props.t("quotes.dialog.success-mb")}</span>
                                                            </div> 
                                                            <div className="col-12 t-align-left mgt-20">
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.entity")} </b>{this.state.mbEntity}</p>
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.reference")} </b>{this.state.mbReference}</p>
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.value")} </b>{this.state.mbValue}</p>
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.due-date")} </b>{this.state.mbDueDate}</p>
                                                            </div>   
                                                        </>
                                                        : null
                                                }
                                                {
                                                    this.state.quotesGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ?
                                                
                                                        <div className="col-12 t-align-center mgt-20">
                                                            <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                            <span style={{fontSize:'15px'}}>{this.props.t("quotes.dialog.success-payment")}</span>
                                                        </div>   
                                                        : null
                                                }
                                                {
                                                    this.state.quotesGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                                
                                                        <div className="col-12 t-align-center mgt-20">
                                                            <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                            <span style={{fontSize:'15px'}}>{this.props.t("quotes.dialog.success-mb-way")}</span>
                                                        </div>   
                                                        : null
                                                }
                                                {
                                                    !this.state.showCardForm && this.state.quotesGenerated === false ?
                                                        <div className="col-6 t-align-left mgt-10">
                                                            <Button className='p-button-danger' label={this.props.t("general.back")} onClick={() => this.updateDialogActiveIndex(1)} />
                                                        </div>  
                                                        : null
                                                }
                                                {
                                                    !this.state.showCardForm && this.props.operation.selectedPaymentMethod !== PAYMENT_METHOD_DEBIT_DIRECT && this.state.quotesGenerated === false ?
                                                        <div className="col-6 t-align-right mgt-10">
                                                            <Button className='p-button-success' label={this.props.t("quotes.dialog.confirm")} onClick={() => this.processQuotePayment()} />
                                                        </div>  
                                                        : null
                                                }
                                                {
                                                    this.state.showCardForm ? 
                                                        <div className="col-12 t-align-left mgt-10">
                                                            <form action={process.env.REACT_APP_BASE_ADDRESS + "/quotes"} className="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                                        </div> 
                                                    : null
                                                }
                                                {
                                                    this.state.showCardForm ?
                                                        <div className="col-6 t-align-left mgt-10">
                                                            <Button className='p-button-danger' label={this.props.t("general.cancel")} onClick={() => this.setState({showCardForm: false })} />
                                                        </div>  
                                                        : null
                                                }
                                            </div>  
                                            : null                   
                                    }
                                </div>
                        }
                    </Dialog>
                    : null
            }
            <Dialog visible={this.state.showQuotePaymentPlanDialog} style={{ width: '1000px' }} header={this.props.t("quotes.dialog.payment-plan-title")} modal onHide={() => this.hideQuotePaymentPlanDialog() }>
                <QuotePaymentPlanCreationComponent quotePaymentPlan={this.props.operation.quotePaymentPlan} submitCallback={() => this.checkAssociateEligibityForQuotePaymentPlan() } onClose={() => this.hideQuotePaymentPlanDialog()} />
            </Dialog>
        </div>
      );
    }
}

const mapStateToProps = (state) => {
  return {
      associate: state.profile.associate,
      ballot: state.profile.ballot,
      operation: state.quote.operation,
      generatedPaymentRef: state.quote.generatedPaymentRef,
      quotes: state.quote.quotes,
      directDebit: state.quote.directDebit,
      settings: state.quote.settings,
      beginSubscriptionPeriodDay: state.quote.beginSubscriptionPeriodDay,
      endSubscriptionPeriodDay: state.quote.endSubscriptionPeriodDay,
      mbMinimumMonths: state.quote.mbMinimumMonths,
      registrationRef: state.authentication.registrationRef
  } 
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) },
    getQuoteList: (associateId) => { dispatch(getQuoteList(associateId)) },
    getQuoteDebitDirectConfiguration: (associateId) => { dispatch(getQuoteDebitDirectConfiguration(associateId)) },
    getQuoteSettingList: () => { dispatch(getQuoteSettingList()) },
    updateQuoteOperationData: (data) => { dispatch(updateQuoteOperationData(data)) },
    updateGeneratedPaymentRef: (paymentRef) => { dispatch(updateGeneratedPaymentRef(paymentRef)) }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(QuotesPage)));